import SuccessMessage from "@/components/SuccessMessage/SuccessMessage.vue";
import ChooseSocialForCampaignModal from "../../components/__new_ui_kit/Modals/NewMode/NewCampaign/ChooseSocialForCampaignModal";
import {defaultModalEvents} from "../../components/__new_ui_kit/Modal/defaults";

import {mapActions, mapGetters} from "vuex";
import NewModeModalAboutExpiring
    from "../../components/__new_ui_kit/Modals/NewMode/NewModeModalAboutExpiring/NewModeModalAboutExpiring";

export default {
    name: "SuccessPay",
    data() {
        return {
            title: 'Thanks for subscribing!',
            message: `Payment is successful. Your plan will be activated within 2 minutes. 
            If your plan hasn’t changed, please contact our <a href="/support">support</a>`
        }
    },
    components: {
        SuccessMessage,
        ChooseSocialForCampaignModal,
        NewModeModalAboutExpiring
    },
    computed: {
        ...mapGetters([
            'isLoggedIn',
            'getActiveSocial',
            'getWidth',
            'userInfo'
        ])
    },
    methods: {
        ...mapActions(['details']),
        redirectToProfile() {
            this.details()
                .then((response) => {
                    this.$router.push('/profile-settings')
                })
                .catch((error) => {
                    console.log(error.response)
                })
        },
        openNewCampaignModal() {
            this.details()
                .then((response) => {
                    this.$modal.show(ChooseSocialForCampaignModal,
                        {
                            name: "choose-social-fo-campaign",
                            verticalScroll: true,
                            goToCreate: () => {
                                this.$router.push('/new-campaign/' + this.getActiveSocial.name.toLowerCase())
                                this.$modal.hide('choose-social-fo-campaign')
                            }
                        },
                        {name: "choose-social-fo-campaign", height: 'auto', width: this.getWidth > 490 ? '480' : '320'},
                        {...defaultModalEvents()}
                    )
                    // if (this.userInfo.without_subscription || this.userInfo.active_plan.campaign_limit <= this.userInfo.content_count) {
                    //     this.$modal.show(NewModeModalAboutExpiring,
                    //         {
                    //             name: "choose-social-fo-campaign",
                    //         },
                    //         { name: "choose-social-fo-campaign", height: 'auto', width: this.getWidth > 490 ? '480' : '320'},
                    //         {...defaultModalEvents()}
                    //     )
                    // } else {
                    //     this.$modal.show(ChooseSocialForCampaignModal,
                    //         {
                    //             name: "choose-social-fo-campaign",
                    //             verticalScroll: true,
                    //             goToCreate: () => {
                    //                 this.$router.push('/new-campaign/' + this.getActiveSocial.name.toLowerCase())
                    //                 this.$modal.hide('choose-social-fo-campaign')
                    //             }
                    //         },
                    //         {name: "choose-social-fo-campaign", height: 'auto', width: this.getWidth > 490 ? '480' : '320'},
                    //         {...defaultModalEvents()}
                    //     )
                    // }
                })
        },
        addGTM(event) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event' : event
            });
        }
    },
    mounted() {
        const url = new URL(document.location.href)
        this.from_trial = url.searchParams.get('sub') === 'trial'

        // if (this.from_trial && String(localStorage.getItem('is_send_trial_event')) === '1') {
        //     this.$router.push('/pricing')
        // }
        //
        // if (this.from_trial && String(localStorage.getItem('is_send_trial_event')) === '0') {
        //     this.addGTM('add_payment_info')
        //     localStorage.setItem('is_send_trial_event', '1')
        // }
        if (this.from_trial) {
            this.title = 'Trial Started'
            this.message = 'Your 7-day free trial will be activated within 2 minutes. You’ll be charged on ' + (!!this.userInfo.subscription_info ? this.userInfo.subscription_info.active_subscription.end_at : this.$moment().add(7, 'days').format('YYYY-MM-DD'))
        }
    }
}
